import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { GeneralAdapter } from '../../adapters/general.adapter';
import { loadDeclineReasons, loadDeclineReasonsFailure, loadDeclineReasonsSuccess } from './decline-reasons.actions';

@Injectable()
export class DeclineReasonsEffects {
  private readonly actions$ = inject(Actions);
  private readonly generalAdapter = inject(GeneralAdapter);

  loadDeclineReasons$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDeclineReasons),
      exhaustMap(() =>
        this.generalAdapter.getDeclineReasons().pipe(
          map((declineReasons) => loadDeclineReasonsSuccess({ declineReasons })),
          catchError((error) => {
            return of(loadDeclineReasonsFailure({ error }));
          })
        )
      )
    )
  );

  loadDeclineReasonsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadDeclineReasonsFailure),
        tap((action) => {
          // Todo: Add proper error handling. Maybe with a toasty?
          //alert(action.error.message);
        })
      ),
    { dispatch: false }
  );
}
